import { request } from "utils/axios";



export const adverts = async () => {
    try {
        const res = await request.get("new-adverts-web");
        const payload = res?.data;

        // Normalize to the legacy advert shape used across the app (Carousel/Layout filters):
        // - `medias[0].platform` + `medias[0].placement` are used for filtering
        // - `medias[0].filename` is the image URL used for rendering
        // - `product_id` is used to deep-link into the product page
        const data = Array.isArray(payload?.data) ? payload.data : [];
        const normalized = data.map((a) => ({
            ...a,
            link: a?.link ?? null,
            medias: [
                {
                    platform: "web",
                    placement: "top",
                    filename: a?.img_url_web ?? a?.image_url ?? a?.filename ?? null,
                },
            ],
        }));

        return { ...payload, data: normalized };
    } catch (err) {
        //console.log(err);
        throw err;
    }
};

export const popUpAdverts = async () => {
    try {
        const res = await request.get("pop-up-adverts-web");
        return res?.data;
    } catch (err) {
        throw err;
    }
};








